import { AccountField } from "./account-field.interface";
import { CurrencyCode, FundingMethodName } from "./service-provider.type";

export enum ProviderType {
	API = "API",
	NON_API = "NON_API"
}

export interface ServiceProviderCreateForm {
	name: string;
	fullName: string;
	logoId: string;
	currencies: CurrencyCode[];
	pushMethod: FundingMethodName;
	pullMethod: FundingMethodName;
	accountFields: AccountField[];
}

export interface ServiceProviderUpdateForm {
	id: string;
	version: number;
	name: string;
	fullName: string;
	currencies: CurrencyCode[];
	pushMethod: FundingMethodName;
	pullMethod: FundingMethodName;
	accountFields: AccountField[];
	logoId: string;
}

export interface ServiceProviderCreateDto {
	name: string;
	fullName: string;
	logoId: string;
	currencies: CurrencyCode[];
	accountFields: AccountField[];
}

export interface ServiceProviderUpdateDto {
	id: string;
	version: number;
	logoId: string;
	currencies: CurrencyCode[];
	fundingMethods: FundingMethodName[];
	accountFields: AccountField[];
}

export interface ServiceProviderList {
	totalCount: number;
	totalPages: number;
	pageNumber: number;
	items: ServiceProviderListItem[];
}

export interface ServiceProviderObject {
	id: string;
	name: string;
	fullName: string;
	logoUrl: string;
}

export interface ServiceProviderFullObject {
	id: string;
	version: number;
	logoId: string;
	status: string;
	data: {
		currencies: CurrencyCode[];
		fullName: string;
		name: string;
		fundingMethods: FundingMethodName[];
		accountFields: AccountField[];
		type: string;
	};
}

export interface ServiceProviderListItem {
	provider: ServiceProviderObject;
	providerCountries: ServiceProviderCountriesPagination;
}

export interface ServiceProviderCountryItem {
	id: string;
	country: {
		code: string;
		name: string;
		flagPath: string;
	};
}

export interface ServiceProviderPagination {
	totalCount: number;
	totalPages: number;
	pageNumber: number;
	items: ServiceProviderListItem[];
}

export interface ServiceProviderCountriesPagination {
	totalCount: number;
	totalPages: number;
	pageNumber: number;
	items: ServiceProviderCountryItem[];
}

export interface AvailableServiceProvider {
	id: string;
	name: string;
	type: ProviderType;
}

export interface ServiceProviderCurrencies {
	providerCountryId: string;
	currencies: string[];
}
